"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _values = require("babel-runtime/core-js/object/values");

var _values2 = _interopRequireDefault(_values);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _languageHandler = require("../../../languageHandler");

var _ = require("../../..");

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2019 The Matrix.org Foundation C.I.C.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var InlineTermsAgreement = function (_React$Component) {
    (0, _inherits3.default)(InlineTermsAgreement, _React$Component);

    function InlineTermsAgreement() {
        (0, _classCallCheck3.default)(this, InlineTermsAgreement);

        var _this = (0, _possibleConstructorReturn3.default)(this, (InlineTermsAgreement.__proto__ || (0, _getPrototypeOf2.default)(InlineTermsAgreement)).call(this));

        _this._togglePolicy = function (index) {
            var policies = JSON.parse((0, _stringify2.default)(_this.state.policies)); // deep & cheap clone
            policies[index].checked = !policies[index].checked;
            _this.setState({ policies: policies });
        };

        _this._onContinue = function () {
            var hasUnchecked = !!_this.state.policies.some(function (p) {
                return !p.checked;
            });
            if (hasUnchecked) return;

            _this.setState({ busy: true });
            _this.props.onFinished(_this.state.policies.map(function (p) {
                return p.url;
            }));
        };

        _this.state = {
            policies: [],
            busy: false
        };
        return _this;
    }

    (0, _createClass3.default)(InlineTermsAgreement, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            // Build all the terms the user needs to accept
            var policies = []; // { checked, url, name }
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.props.policiesAndServicePairs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var servicePolicies = _step.value;

                    var availablePolicies = (0, _values2.default)(servicePolicies.policies);
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = (0, _getIterator3.default)(availablePolicies), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var policy = _step2.value;

                            var language = (0, _languageHandler.pickBestLanguage)((0, _keys2.default)(policy).filter(function (p) {
                                return p !== 'version';
                            }));
                            var renderablePolicy = {
                                checked: false,
                                url: policy[language].url,
                                name: policy[language].name
                            };
                            policies.push(renderablePolicy);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.setState({ policies: policies });
        }
    }, {
        key: "_renderCheckboxes",
        value: function _renderCheckboxes() {
            var _this2 = this;

            var rendered = [];

            var _loop = function _loop(i) {
                var policy = _this2.state.policies[i];
                var introText = (0, _languageHandler._t)("Accept <policyLink /> to continue:", {}, {
                    policyLink: function policyLink() {
                        return _react2.default.createElement(
                            "a",
                            { href: policy.url, rel: "noopener", target: "_blank" },
                            policy.name,
                            _react2.default.createElement("span", { className: "mx_InlineTermsAgreement_link" })
                        );
                    }
                });
                rendered.push(_react2.default.createElement(
                    "div",
                    { key: i, className: "mx_InlineTermsAgreement_cbContainer" },
                    _react2.default.createElement(
                        "div",
                        null,
                        introText
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "mx_InlineTermsAgreement_checkbox" },
                        _react2.default.createElement("input", { type: "checkbox", onChange: function onChange() {
                                return _this2._togglePolicy(i);
                            }, checked: policy.checked }),
                        (0, _languageHandler._t)("Accept")
                    )
                ));
            };

            for (var i = 0; i < this.state.policies.length; i++) {
                _loop(i);
            }
            return rendered;
        }
    }, {
        key: "render",
        value: function render() {
            var AccessibleButton = _2.default.getComponent("views.elements.AccessibleButton");
            var hasUnchecked = !!this.state.policies.some(function (p) {
                return !p.checked;
            });

            return _react2.default.createElement(
                "div",
                null,
                this.props.introElement,
                this._renderCheckboxes(),
                _react2.default.createElement(
                    AccessibleButton,
                    {
                        onClick: this._onContinue,
                        disabled: hasUnchecked || this.state.busy,
                        kind: "primary_sm"
                    },
                    (0, _languageHandler._t)("Continue")
                )
            );
        }
    }]);
    return InlineTermsAgreement;
}(_react2.default.Component);

InlineTermsAgreement.propTypes = {
    policiesAndServicePairs: _propTypes2.default.array.isRequired, // array of service/policy pairs
    agreedUrls: _propTypes2.default.array.isRequired, // array of URLs the user has accepted
    onFinished: _propTypes2.default.func.isRequired, // takes an argument of accepted URLs
    introElement: _propTypes2.default.node
};
exports.default = InlineTermsAgreement;
module.exports = exports["default"];
//# sourceMappingURL=InlineTermsAgreement.js.map